import { Button, CircularProgress } from "@mui/material";
import ConnectionTestResult from "./ConnectionTestResult";

function verifiedText(connection) {
  if (!connection.verifiedAt) return "Saved, not yet verified";
  return `Verified ${new Date(connection.verifiedAt).toLocaleString("en-AU")}`;
}

export default function ConnectionCard({
  connection,
  canConnect,
  testing,
  result,
  onTest,
  onEdit,
  onRemove,
}) {
  return (
    <div className="space-y-3 rounded border border-app-border bg-app-surface p-4">
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div>
          <h3 className="font-semibold">{connection.label}</h3>
          <p className="text-sm text-app-text-secondary">
            {verifiedText(connection)}
            {connection.currency ? ` · Currency ${connection.currency}` : ""}
          </p>
          <p className="text-xs text-app-text-muted">
            Ad account {connection.adAccountId} · Page {connection.pageId}
            {connection.instagramUserId ? ` · Instagram ${connection.instagramUserId}` : ""}
          </p>
        </div>
        {canConnect ? (
          <div className="flex flex-wrap gap-1">
            <Button
              size="small"
              variant="outlined"
              disabled={testing}
              startIcon={testing ? <CircularProgress size={14} /> : null}
              onClick={() => onTest(connection)}
            >
              Test connection
            </Button>
            <Button size="small" onClick={() => onEdit(connection)}>
              Edit
            </Button>
            <Button size="small" color="warning" onClick={() => onRemove(connection)}>
              Remove
            </Button>
          </div>
        ) : null}
      </div>
      <ConnectionTestResult result={result} />
    </div>
  );
}
